import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1650. 受注案件契約タスク削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_contract_tasks/sales_order_contract_task_id
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  id: number;
};
const destroySalesOrderContractTask = (props: Props) => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sales_order_contract_tasks/${props.id}`
  );
};
export const useDestroySalesOrderContractTask = () => {
  return useMutation({
    mutationFn: destroySalesOrderContractTask
  });
};
